<template>
  <div class="t-bounds">
    <div class="t-panel-section">
      <div class="t-panel-heading">
        <div v-if="heading">
          {{ heading }}
        </div>
        <a
          v-else-if="settings.detailLink ?? pubInfo.detailUrl"
          :href="settings.detailLink ?? pubInfo.detailUrl"
        >
          {{ pubInfo.title }}
        </a>
        <span v-else>
          {{ pubInfo.title }}
        </span>
      </div>
    </div>
    <div
      v-if="!attachmentsList || !attachmentsList.length"
      class="t-panel-section"
    >
      <p>There are no attachments available on this page.</p>
    </div>
    <div
      v-else
      v-for="(al, ali) in attachmentsList"
      :key="ali"
      class="t-panel-section"
    >
      <div class="t-panel-subheading">{{ al.heading }}</div>
      <ul class="t-panel-list">
        <li v-for="(a, ai) in al.attachments" :key="ai" class="t-panel-item">
          <a
            :href="a.href"
            :target="a.target"
            :rel="a.rel"
            class="t-attachment"
          >
            {{ a.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import './common';

.t-attachment {
  font-weight: bold;
  color: $defaultColor;
}
</style>

<script>
import api from '../services/api'

export default {
  name: 'AttachmentsPanel',

  props: {
    page: {
      type: Object,
      required: true,
    },
    pubInfo: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      attachmentsList: null,
      heading: '',
    }
  },

  watch: {
    page() {
      this.attachmentsList = null
      this.update()
    },
    visible() {
      this.update()
    },
  },

  created() {
    this.update()
  },

  methods: {
    update() {
      if (this.attachmentsList || !this.visible) {
        return
      }

      // We're gonna fill this, make it truthy
      this.attachmentsList = []

      // Capture against async
      const {page} = this

      api.getReaderAttachments(page.attachmentsUrl).then(r => {
        if (page === this.page) {
          this.heading = r.heading === this.pubInfo.title ? '' : r.heading
          this.attachmentsList = r.result
        }
      })
    },
  },

  inject: ['settings'],
}
</script>
